import * as React from 'react';
import { url } from 'src';
import { CardEvent } from 'src/store/events/types';
import { User } from 'src/store/user/types';
import { formatDate } from 'src/utils/dateHelper';
import './DailyPrint.scss';

interface Props {
  headerText: string;
  events: CardEvent[];
  user: User;
  printingDone: () => any;
}

interface State {
  counter: number;
  goal: number;
}

export class DailyPrint extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      counter: 0,
      goal: 0
    };
  }

  componentDidMount() {
    let count = 0;
    this.props.events.forEach(ev => {
      if (ev.image && ev.image.url) {
        count++;
      }
    });
    this.setState({ goal: count });
  }

  renderInfo = (event: CardEvent) => (
    <div className="info">
      <table className="eventInfoTable" style={{ textAlign: 'left' }}>
        <tbody>
          {event.begins && (
            <tr>
              <td>
                <span className="bold">Startzeit: </span>
              </td>
              <td>{formatDate(event.begins, 'HH:mm')} Uhr</td>
            </tr>
          )}
          {event.price && (
            <tr>
              <td>
                <span className="bold nowrap">Preis ohne Erlebnis CARD:</span>
              </td>
              <td>{event.price} €</td>
            </tr>
          )}
          {event.meetingpoint && (
            <tr>
              <td>
                <span className="bold">Treffpunkt: </span>
              </td>
              <td>{event.meetingpoint}</td>
            </tr>
          )}
          {event.duration && (
            <tr>
              <td>
                <span className="bold">Dauer: </span>
              </td>

              <td>{event.duration}</td>
            </tr>
          )}
        </tbody>
      </table>
      <div className="shortDesc">
        {event &&
          event.shortDescription.split('\n').map((item: string, key: number) => {
            return (
              <span key={key}>
                {item}
                <br />
              </span>
            );
          })}
      </div>
    </div>
  );

  renderEvents = () => {
    return this.props.events.map((ev, i) => {
      return (
        <div className="eventItem" key={i}>
          <div className="wrapper">
            <div className="border bottom clearfix eventItemHeader">
              <div className="fifty">
                <div className="imagediv">
                  {ev.image && <img onLoad={this.imageLoaded} src={url + ev.image.url} />}
                </div>
              </div>
              <div className="fifty">{this.renderInfo(ev)}</div>
            </div>
            <div>
              <span
                style={{
                  color: '#000',
                  fontWeight: 700,
                  textAlign: 'left',
                  fontSize: '8pt',
                  display: 'block',
                  lineHeight: '1',
                  margin: '10px 0 5px 0'
                }}
              >
                {formatDate(ev.begins, 'DD.MM.YYYY')}
              </span>
              <h1 style={{ margin: '0', fontWeight: 700, textAlign: 'left', fontSize: '10pt' }}>
                {ev.title}
              </h1>
              <div className="desc">
                {ev &&
                  ev.description.split(/<br \/>|[\n]+/).map((item: string, key: number) => {
                    return (
                      <span key={key}>
                        {item}
                        <br />
                      </span>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  imageLoaded = () => {
    this.setState({ counter: this.state.counter + 1 }, () => {
      if (this.state.counter >= this.state.goal) {
        window.print();
      }
    });
  };

  render() {
    const { user, headerText } = this.props;
    return (
      <div>
        <div
          className="border bottom clearfix"
          style={{ marginBottom: '20px', paddingBottom: '10px' }}
        >
          <h1
            style={{
              fontWeight: 400,
              fontSize: '14pt',
              width: '80%',
              display: 'inline-block',
              textAlign: 'left',
              float: 'left'
            }}
          >
            Tagesprogramm,
            <br /> {headerText}
          </h1>
          <h2
            style={{
              fontWeight: 700,
              fontSize: '12pt',
              width: '80%',
              display: 'inline-block',
              textAlign: 'left',
              float: 'left'
            }}
          >
            {user.name}
          </h2>
          {user.image && <img height="50px" width="auto" src={url + user.image.url} />}
        </div>
        <div className="eventList clearfix">{this.renderEvents()}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/utils/Print/DailyPrint/DailyPrint.tsx